import { createFileRoute } from '@tanstack/react-router'
import { PersonPage } from '~/features/people/PersonPage'
import { PERSON_TABS, type PersonTab } from '~/features/people/search'
import { loaderScope, personQuery } from '~/features/people/queries'

export const Route = createFileRoute('/_app/kader/$personId')({
  // ?zusammenfuehren=<id> opens the merge with that person (Prämien hint "Namensvetter gefunden").
  validateSearch: (s: Record<string, unknown>): { tab?: PersonTab; zusammenfuehren?: string } => ({
    ...(typeof s.tab === 'string' && (PERSON_TABS as readonly string[]).includes(s.tab) && s.tab !== 'ueberblick' ? { tab: s.tab as PersonTab } : {}),
    ...(typeof s.zusammenfuehren === 'string' && /^[0-9a-f-]{36}$/i.test(s.zusammenfuehren) ? { zusammenfuehren: s.zusammenfuehren } : {}),
  }),
  loader: async ({ context, params }) => {
    const scope = await loaderScope(context.queryClient)
    if (scope) await context.queryClient.ensureQueryData(personQuery(params.personId, scope.teamId, scope.season)).catch(() => undefined)
  },
  component: function Person() {
    const { personId } = Route.useParams()
    const { tab, zusammenfuehren } = Route.useSearch()
    return <PersonPage personId={personId} tab={tab ?? 'ueberblick'} {...(zusammenfuehren ? { mergeWith: zusammenfuehren } : {})} />
  },
})
